/*
 * @Description: 商品管理列表
 * @Author: AI Assistant
 * @LastEditors: AI Assistant
 */
import React, { useState, useEffect } from 'react';
import { Table, Button, Input, Dialog, Form } from '@alifd/next';
import LzPagination from '@/components/common/LzPagination';
import LzMsg from '@/components/common/LzMsg';
import utils from '@/common/utils';
import { Servlets } from '@/service';
import style from './index.module.scss';

const GoodsManageList = (): JSX.Element => {
  const [isLoading, setIsLoading] = useState(false);
  const [dataSource, setDataSource] = useState<any[]>([]);
  const [pageInfo, setPageInfo] = useState({ pageNo: 1, pageSize: 10, total: 0 });
  const [skuIdValue, setSkuIdValue] = useState('');
  // 批量删除选中的 id 列表
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
  // 删除弹窗
  const [deletevisible, setDelete] = useState(false);
  // 待删除的 id 列表（单条/批量共用）
  const [removeIds, setRemoveIds] = useState<any[]>([]);

  useEffect(() => {
    utils.setBreadcrumb({ name: '商品管理' });
    init();
  }, []);

  const init = (): void => {
    fetchListData();
  };

  // 获取商品列表
  const fetchListData = (params?: Record<string, any>): void => {
    setIsLoading(true);
    Servlets('getGoodsSku', {
      pageSize: params?.pageSize || pageInfo.pageSize,
      pageNo: params?.pageNo || pageInfo.pageNo,
      skuIds: params?.skuIds ?? skuIdValue,
    }).then((res: any) => {
      setDataSource(res.data || []);
      setPageInfo(res.page || { pageNo: 1, pageSize: 10, total: 0 });
      setSelectedRowKeys([]);
      setIsLoading(false);
    }).catch(() => {
      setIsLoading(false);
    });
  };

  // 查询
  const handleSearch = (): void => {
    fetchListData({ pageNo: 1 });
  };

  // 重置
  const handleReset = (): void => {
    setSkuIdValue('');
    fetchListData({ pageNo: 1, pageSize: 10, skuIds: '' });
  };

  // 翻页
  const handlePageSizeChange = (pages: Record<string, number>): void => {
    setPageInfo(prev => ({ ...prev, ...pages }));
    fetchListData({
      pageSize: pages.pageSize,
      pageNo: pages.pageNo,
      skuIds: skuIdValue,
    });
  };

  // 打开删除弹窗 - 单条
  const openDelete = (skuId: string): void => {
    setRemoveIds([skuId]);
    setDelete(true);
  };

  // 打开删除弹窗 - 批量
  const openBatchDelete = (): void => {
    if (selectedRowKeys.length === 0) {
      LzMsg.error('请选择需要删除的数据');
      return;
    }
    setRemoveIds(selectedRowKeys);
    setDelete(true);
  };

  // 确认删除
  const onRemove = (ids: any[]): void => {
    setIsLoading(true);
    if (ids.length !== 0) {
      // TODO: 替换为真实删除接口
      // Servlets('deleteGoodsSkuById', { ids }).then(...)
      setTimeout(() => {
        setDelete(false);
        setDataSource(prev => prev.filter(item => !ids.includes(item.skuId)));
        setPageInfo(prev => ({ ...prev, total: prev.total - ids.length }));
        setSelectedRowKeys([]);
        setIsLoading(false);
        LzMsg.success('删除成功');
      }, 300);
    }
  };

  // 下载模板
  const handleDownloadTemplate = (): void => {
    // TODO: 替换为真实下载模板接口
    LzMsg.warning('下载模板功能开发中');
  };

  // 全部导出
  const handleExportAll = (): void => {
    // TODO: 替换为真实导出接口
    LzMsg.warning('全部导出功能开发中');
  };

  // 导入数据
  const handleImportData = (): void => {
    // TODO: 替换为真实导入功能
    LzMsg.warning('导入数据功能开发中');
  };

  // 操作列渲染
  const renderOprate = (value: any, index: number, record: any) => (
    <Button type="primary" text onClick={() => openDelete(record.skuId)}>
      删除
    </Button>
  );

  return (
    <div>
      <div className={style.goodsManageList}>
        <section className="lz-section">
          <div className={style.currentList}>
            {/* 搜索区域 */}
            <div className={style.listSearch}>
              <Form
                inline
                className={`${style.listSearchForm} form-crowdMarketing`}
                size="medium"
              >
                <Form.Item label="SKUID" className={style.formItemFull}>
                  <Input
                    placeholder="请输入"
                    value={skuIdValue}
                    onChange={(val: string) => setSkuIdValue(val)}
                    onPressEnter={handleSearch}
                    name="skuIds"
                    className={style.inputWidth300}
                    hasClear
                  />
                </Form.Item>
                <Form.Item label=" " className={style.formItemBtn}>
                  <Button type="primary" className={`${style.mr10} ${style.w88}`} onClick={handleSearch}>
                    查询
                  </Button>
                  <Button type="normal" className={style.w88} onClick={handleReset}>
                    重置
                  </Button>
                </Form.Item>
              </Form>
            </div>

            {/* 表格区域 */}
            <div className={style.childBox}>
              {/* 操作栏 */}
              {/* <div className={style.operationBar}>
                <Button type="normal" onClick={openBatchDelete}>批量删除</Button>
                <Button type="normal" onClick={handleDownloadTemplate}>下载模板</Button>
                <Button type="normal" onClick={handleExportAll}>批量导出</Button>
                <Button type="normal" onClick={handleImportData}>导入数据</Button>
              </div> */}

              <Table
                loading={isLoading}
                dataSource={dataSource}
                className={style.customTable}
                primaryKey="skuId"
                // rowSelection={{
                //   onChange: (keys: any[]) => setSelectedRowKeys(keys),
                // }}
              >
                <Table.Column title="SKUID" dataIndex="skuId" width="300" />
                <Table.Column title="最后更新时间" dataIndex="updateTime" width="300" cell={(val: string) => val || '/'} />
                {/* <Table.Column title="操作" cell={renderOprate} width="80" /> */}
              </Table>

              <LzPagination pageInfo={pageInfo} onChange={handlePageSizeChange} />
            </div>

            {/* 删除确认弹窗 */}
            <Dialog
              visible={deletevisible}
              className={style.deleteDialog}
              height="150px"
              footer={
                <div className={style.dialogFooter}>
                  <Button type="normal" onClick={() => { setDelete(false); setRemoveIds([]); }}>取消</Button>&nbsp;
                  <Button type="primary" onClick={() => onRemove(removeIds)}>继续</Button>
                </div>
              }
              onClose={() => { setDelete(false); setRemoveIds([]); }}
            >
              <p>删除后无法找回，是否确认删除？</p>
            </Dialog>
          </div>
        </section>
      </div>
    </div>
  );
};

export default GoodsManageList;
